import React from 'react';
import Lottie from 'lottie-react';
import loaderAnimation from '../../../assets/lottie/Loader.json';

export interface LoaderProps {
  /**
   * Text to display below the loader animation
   */
  text?: string;
  /**
   * Additional CSS classes
   */
  className?: string;
  /**
   * Size of the loader animation (default: 100px)
   */
  size?: number;
}

/**
 * Reusable Loader Component
 * Displays a Lottie animation with optional text below
 */
export const Loader: React.FC<LoaderProps> = ({
  text,
  className = '',
  size = 100,
}) => {
  return (
    <div
      className={`flex flex-col items-center justify-center gap-[24px] ${className}`}
    >
      <div
        style={{
          height: `${size}px`,
          width: `${size}px`,
        }}
      >
        <Lottie
          animationData={loaderAnimation}
          loop
          style={{
            height: '100%',
            width: '100%',
          }}
          rendererSettings={{
            preserveAspectRatio: 'xMidYMid meet',
          }}
        />
      </div>
      {text && (
        <p className="text-bodyLarge font-normal text-neutral-10 align-middle">
          {text}
        </p>
      )}
    </div>
  );
};

export default Loader;
